<template>
  <div id=findPass>
    <div class="logintitle">
      <img class="logoimg" src="/static/img/logo.png">
    </div>
    <div class="inputcont">
      <img class="fl headtext" src="/static/img/mobile.png">
      <input placeholder="请输入手机号" class="text" type="text"
      v-model="mobile">
    </div>
    <div class="inputcont">
      <div class="wd100">
        <img class="fl headtext" src="/static/img/yzm.png">
        <input placeholder="请输入验证码" class="text wd65" type="text" v-model="mobileCode">
        <button class="fr findpasscodebtn" @click="getCode()" v-bind:disabled="flag">{{codeValue}}</button>
      </div>
    </div>
    <div class="loginbtdiv"><mt-button class="login-btn" size="large" type="primary" @click="sure()">下一步</mt-button>
    </div>
  </div>
</template>

<script>
  import { Toast } from 'mint-ui';
  export default {
    name: 'findPass',
    data () {
      return {
        mobile: '',
        mobileCode: '',
        isPass: 'true',
        inputType: 'password',
        count: 60,
        codeValue:'获取验证码',
        flag: false,
        outTimer:''
      }
    },
    methods: {
      sure: function(){
        if (this.mobile == null || this.mobile == '') {
          this.$toast("请输入手机号");
          return;
        }
        var reg = /^1[3|4|5|7|8][0-9]{9}$/;
        if (!reg.test(this.mobile)) {
          this.$toast("请输入正确的手机号");
          return;
        }
        if (this.mobileCode == null || this.mobileCode == '') {
          this.$toast("请输入验证码");
          return;
        }
        var that = this;
        this.$http.post(
            domain("_findpassUrl"),
            {
              'mobile':this.mobile,
              'mobileCode':this.mobileCode,
              'mobileType':13    
            },
            {emulateJSON: true}
        )
        .then(function(response){  //接口返回数据
            if(response.body.code == '0'){
                this.$router.push({name: 'setpass', query:{mobile: that.mobile,mobileCode: that.mobileCode}});
            }else if(response.body.code == '11'){
                this.$toast('帐号未注册');
            }else{
                this.$toast('验证码错误');
            }
            },function(error){
        })
      },
      getCode:function(){
        if (this.mobile == null || this.mobile == '') {
          this.$toast("请输入手机号");
          return;
        }
        var reg = /^1[3|4|5|7|8][0-9]{9}$/;
        if (!reg.test(this.mobile)) {
          this.$toast("请输入正确的手机号");
          return;
        }
        this.$http.post(
            domain("_checkFindPass"),
            {
              'loginCode':this.mobile 
            },
            {emulateJSON: true}
        )
        .then(function(response){  //接口返回数据
            if(response.body.code == '0'){
                this.$toast('该手机号未注册');
            }else{
            	this.$http.post(
		            domain("_getyzmUrl"),
		            {
		              'mobile':this.mobile,
		              'mobileType':13    
		            },
		            {emulateJSON: true}
		        )
		        .then(function(response){  //接口返回数据
		            if(response.body.code == '0'){
		                this.$toast('验证码已发送,请查收');
		                this.settime();
		            }else{
		                this.$toast('获取验证码失败,请稍后重试');
		            }
		            },function(error){
		        })
            }
         })
      },
      settime:function(){
        var that = this;
        if (this.count == 0) {
          this.count = 60;
          this.flag = false;
          this.codeValue = '获取验证码';
          if(this.outTimer != null){
            this.outTimer = null;
            return;
          }
        }
        this.flag = true;
        this.count--;
        this.codeValue = "重新发送(" + this.count + "s)";
        this.outTimer = setTimeout(function() {that.settime()},1000);
      }
    },
    components:{
      
    }
  }
</script>
<style>
  .logintitle{
    text-align: center;
    padding: 40px 0;
    font-size: 32px;
    color: #7d7d7d;
  }
  .logoimg{
    width:120px;
  }
  .headtext{
    position: absolute;
    top: 15px;
    left:30px;
  }
  .inputcont input{
    padding-left:50px;
  }
  .inputcont{
    position: relative;
    padding: 0 10px;
    margin-bottom:25px;
  }
  .spwd{
    position: absolute;
    left: 100%;
    margin-left: -40px;
    top: 20px;
  }
  .inputcont img{
    width: 15px;
  }
  .loginbtdiv{
    padding: 0 10px;
  }
  .bottomlogin{
    margin-top: 10px;
    padding: 0 12px;
  }
  .bottomlogin a{
    color: #7d7d7d;
  }
  .wd100{
    width: 100%;
  }
  .wd65{
    width: 57%;
  }
  .findpasscodebtn{
    font-size: 18px;
    cursor:pointer;
    height:50px;
    line-height: 50px;
    border:#e5e5e5 solid 1px;
    background-color: #ffffff;
    border-radius: 4px;
    -ms-border-radius: 4px;
    -moz-border-radius: 4px;
    -o-border-radius: 4px;
    -webkit-border-radius: 4px;
    color: #7d7d7d;
    width:40%;
  }
</style>



// WEBPACK FOOTER //
// src/module/findpass/FindPass.vue